var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"justify-content-around pricing",attrs:{"id":"pricing"}},[_c('h2',{staticClass:"text-center my-5 text-uppercase"},[_vm._v("Formules")]),_vm._l((_vm.plans),function(plan,index){return _c('PricingCard',{key:index,attrs:{"plan":plan},on:{"subscribe":function($event){return _vm.subscribe($event)}}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }